import { Label } from 'components/atoms';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { PiCheckCircleBold, PiCircleBold, PiVideo, PiVinylRecord } from 'react-icons/pi';
import { DIGITAL_PRODUCT_TYPE } from 'services/music-product-digital/types/enums';
import { ACTIVE_STATUS } from 'services/types';
import { IColorProp } from 'types/components/components.interface';

export interface ILabeledStatusProps {
  status: DIGITAL_PRODUCT_TYPE;
}

interface ILabeledStatusParams extends IColorProp {
  status: DIGITAL_PRODUCT_TYPE;
  icon: ReactNode;
}

const labeledStatusParams: ILabeledStatusParams[] = [
  {
    status: DIGITAL_PRODUCT_TYPE.video,
    color: 'green',
    icon: <PiVideo />,
  },
  {
    status: DIGITAL_PRODUCT_TYPE.audio,
    color: 'blue',
    icon: <PiVinylRecord />,
  },
];

const LabeledProductType = ({ status }: ILabeledStatusProps) => {
  const { t } = useTranslation();
  const labeledParams =
    labeledStatusParams.find(params => params.status === status) ??
    labeledStatusParams[0];
  return (
    <Label
      size='compact'
      color={labeledParams.color}
      title={t(`${labeledParams.status}`)}>
      {labeledParams.icon}{' '}
      {t(`enum.DIGITAL_PRODUCT_TYPE.${DIGITAL_PRODUCT_TYPE[labeledParams.status]}`)}
    </Label>
  );
};

export default LabeledProductType;
